<template>
  <div class="project_container">
    <js-banner
      title="服务项目"
    />
    <div class="project_wrapper">
      <js-group
        zh="服务项目"
        en="Our Service"
        :list="group"
      />
      <router-view class="content_container"/>
    </div>
  </div>
</template>

<script>
import JsBanner from '@/packages/JsBanner'
import JsGroup from '@/packages/JsGroup'
export default {
  name: 'about',
  components: {
    JsBanner,
    JsGroup
  },
  data () {
    return {
      group: [{
        id: Math.random().toString(),
        label: '速递业务',
        path: '/project/express'
      }, {
        id: Math.random().toString(),
        label: '跨境电商',
        path: '/project/cross-border'
      }, {
        id: Math.random().toString(),
        label: '空运业务',
        path: '/project/air-freight'
      }, {
        id: Math.random().toString(),
        label: '海运业务',
        path: '/project/shipping'
      }, {
        id: Math.random().toString(),
        label: '内贸运输',
        path: '/project/internal-trade'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.project_wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  padding: 15px 0;
  .content_container {
    flex: 1;
    margin-left: 30px;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
}
</style>
